'use client'

import { useState } from 'react'

const WHATSAPP_NUMBER = '5561999969213'
const FUNILCHATBOT_WEBHOOK = 'https://api.funilchatbot.com.br/wh/JvVtgM2KtxAVrgl-'

const DDI_OPTIONS = [
  { code: '+55', label: 'BR +55' },
  { code: '+1', label: 'US +1' },
  { code: '+351', label: 'PT +351' },
  { code: '+34', label: 'ES +34' },
  { code: '+44', label: 'UK +44' },
  { code: '+33', label: 'FR +33' },
  { code: '+49', label: 'DE +49' },
  { code: '+39', label: 'IT +39' },
  { code: '+81', label: 'JP +81' },
  { code: '+54', label: 'AR +54' },
  { code: '+56', label: 'CL +56' },
  { code: '+57', label: 'CO +57' },
  { code: '+52', label: 'MX +52' },
]

const WA_ICON = (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
)

export function ContatoWhatsApp() {
  const [showForm, setShowForm] = useState(false)
  const [nome, setNome] = useState('')
  const [ddi, setDdi] = useState('+55')
  const [telefone, setTelefone] = useState('')
  const [assunto, setAssunto] = useState('')
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  function handleWhatsApp() {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá! Gostaria de falar com a equipe ebuz.')}`
    window.open(url, '_blank')
  }

  async function handleCallback(e: React.FormEvent) {
    e.preventDefault()
    if (!nome.trim() || !telefone.trim()) return

    setSending(true)
    setError('')

    try {
      const numero = telefone.replace(/\D/g, '')
      const res = await fetch('/api/contato', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: nome.trim(),
          phone: numero,
          ddi: ddi,
          message: assunto.trim() || 'Contato via site',
          source: 'site',
        }),
      })

      if (!res.ok) throw new Error('Falha ao enviar')

      setSent(true)
      setNome('')
      setTelefone('')
      setAssunto('')

      // Funil Chatbot webhook (fire-and-forget)
      const ddiDigits = ddi.replace(/\D/g, '')
      fetch(FUNILCHATBOT_WEBHOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome: nome.trim(),
          telefone: ddiDigits + numero,
          mensagem: assunto.trim() || 'Contato via site',
        }),
      }).catch(() => {})
    } catch {
      setError('Não foi possível enviar. Tente pelo WhatsApp direto.')
    } finally {
      setSending(false)
    }
  }

  if (sent) {
    return (
      <div className="bg-white border border-green-200 rounded-xl p-4 sm:p-5 text-center">
        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
          <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="text-sm font-semibold text-gray-900 mb-1">Recebemos seu contato!</p>
        <p className="text-xs text-gray-500 mb-3">Entraremos em contato pelo WhatsApp em breve.</p>
        <button onClick={() => setSent(false)} className="text-xs text-gray-400 hover:text-gray-700 transition-colors">
          Enviar novamente
        </button>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {/* Botão WhatsApp direto */}
      <div className="bg-white border border-gray-200 rounded-xl p-4 sm:p-5">
        <h2 className="text-sm font-semibold text-gray-900 mb-2">WhatsApp</h2>
        <p className="text-xs text-gray-500 mb-3">Fale diretamente com nossa equipe.</p>
        <button
          onClick={handleWhatsApp}
          className="w-full inline-flex items-center justify-center gap-2 bg-green-600 text-white px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-green-700 transition-colors"
        >
          {WA_ICON}
          Abrir WhatsApp
        </button>
      </div>

      {/* Callback: te ligamos */}
      <div className="bg-white border border-gray-200 rounded-xl p-4 sm:p-5">
        <h2 className="text-sm font-semibold text-gray-900 mb-1">Prefere que a gente te chame?</h2>
        <p className="text-xs text-gray-500 mb-3">Deixe seu número e entramos em contato.</p>

        {!showForm ? (
          <button
            onClick={() => setShowForm(true)}
            className="w-full border border-gray-200 text-gray-700 px-4 py-2.5 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"
          >
            Deixar meu número
          </button>
        ) : (
          <form onSubmit={handleCallback} className="space-y-3">
            <div>
              <label className="block text-xs text-gray-500 mb-1">Nome *</label>
              <input
                type="text"
                required
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-gray-400"
                placeholder="Seu nome"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-500 mb-1">Telefone com WhatsApp *</label>
              <div className="flex gap-1.5">
                <select
                  value={ddi}
                  onChange={(e) => setDdi(e.target.value)}
                  className="w-24 shrink-0 px-2 py-2 border border-gray-200 rounded-lg text-xs focus:outline-none focus:border-gray-400 bg-white"
                >
                  {DDI_OPTIONS.map((opt) => (
                    <option key={opt.code} value={opt.code}>{opt.label}</option>
                  ))}
                </select>
                <input
                  type="tel"
                  required
                  value={telefone}
                  onChange={(e) => setTelefone(e.target.value)}
                  className="flex-1 px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-gray-400"
                  placeholder="(61) 99999-9999"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs text-gray-500 mb-1">Assunto</label>
              <input
                type="text"
                value={assunto}
                onChange={(e) => setAssunto(e.target.value)}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-gray-400"
                placeholder="Sobre o que gostaria de falar?"
              />
            </div>

            {error && (
              <p className="text-xs text-red-600 bg-red-50 px-3 py-2 rounded-lg">{error}</p>
            )}

            <button
              type="submit"
              disabled={sending}
              className="w-full bg-green-600 text-white py-2.5 rounded-lg text-sm font-semibold hover:bg-green-700 transition-colors disabled:opacity-50"
            >
              {sending ? 'Enviando...' : 'Quero que me chamem'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
